import script from "./PdBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PdBadge.vue?vue&type=script&setup=true&lang=js"

import "./PdBadge.vue?vue&type=style&index=0&id=3bd8041b&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd8041b"]])

export default __exports__